var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransportSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 15.2969C4.125 15.7527 4.30608 16.1899 4.62841 16.5122C4.95074 16.8345 5.38791 17.0156 5.84375 17.0156C6.29959 17.0156 6.73676 16.8345 7.05909 16.5122C7.38142 16.1899 7.5625 15.7527 7.5625 15.2969C7.5625 14.841 7.38142 14.4039 7.05909 14.0815C6.73676 13.7592 6.29959 13.5781 5.84375 13.5781C5.38791 13.5781 4.95074 13.7592 4.62841 14.0815C4.30608 14.4039 4.125 14.841 4.125 15.2969Z",
    stroke: "#5C5E69",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 15.2969C14.4375 15.7527 14.6186 16.1899 14.9409 16.5122C15.2632 16.8345 15.7004 17.0156 16.1562 17.0156C16.6121 17.0156 17.0493 16.8345 17.3716 16.5122C17.6939 16.1899 17.875 15.7527 17.875 15.2969C17.875 14.841 17.6939 14.4039 17.3716 14.0815C17.0493 13.7592 16.6121 13.5781 16.1562 13.5781C15.7004 13.5781 15.2632 13.7592 14.9409 14.0815C14.6186 14.4039 14.4375 14.841 14.4375 15.2969Z",
    stroke: "#5C5E69",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 15.2969H2.40625V5.84375C2.40625 5.61583 2.49679 5.39724 2.65796 5.23608C2.81912 5.07492 3.0377 4.98438 3.26562 4.98438H15.2969C15.8611 4.98437 16.4199 5.13997 16.9412 5.44229C17.4625 5.7446 17.9362 6.18771 18.3352 6.74631C18.7342 7.30491 19.0507 7.96807 19.2667 8.69792C19.4826 9.42777 19.5937 10.21 19.5938 11V15.2969H17.875M14.4375 15.2969H7.5625",
    stroke: "#5C5E69",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 4.98438L15.7266 11H19.5938",
    stroke: "#5C5E69",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40625 9.28125H15.2969",
    stroke: "#5C5E69",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70312 4.98438V9.28125",
    stroke: "#5C5E69",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11 4.98438V9.28125",
    stroke: "#5C5E69",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportSchedule);
export default __webpack_public_path__ + "static/media/transport-schedule.a4073e0a1b0f6ae56a3c75b8399d049f.svg";
export { ForwardRef as ReactComponent };